interface TcgCardProps {
  title: string;
  imageUrl: string;
  onOpen: () => void;
}

export const TcgCard = ({ title, imageUrl, onOpen }: TcgCardProps) => (
  <button
    type="button"
    className="surface-card surface-card--interactive flex w-full flex-col overflow-hidden text-left"
    onClick={onOpen}
    aria-label={title}
  >
    <div className="aspect-square w-full bg-white/[0.03] p-2">
      <img
        src={imageUrl}
        alt=""
        width={320}
        height={320}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-contain"
      />
    </div>
    <p className="m-0 px-3 py-2.5 text-center text-[0.78rem] font-semibold leading-snug text-[#c8c8dc] [overflow-wrap:anywhere]">
      {title}
    </p>
  </button>
);
